export const SINGLE_COLUMN_BREAKPOINT_PX = 1151;
